import { render, staticRenderFns } from "./commonBtn.vue?vue&type=template&id=e4b12b42"
import script from "./commonBtn.vue?vue&type=script&lang=js"
export * from "./commonBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports